<template>
  <span class="logo-animated-o">
    <svg
      width="305"
      height="297"
      viewBox="0 0 305 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M156.228 0.0267796C202.407 0.0267796 239.633 15.138 265.262 41.5023C290.863 67.8398 305 105.377 305 150.041C305 194.705 290.863 231.491 265.262 257.052C239.633 282.639 202.407 297 156.228 297H147.249C101.818 297 64.9389 282.639 39.5245 257.078C14.1368 231.491 0 194.812 0 150.041C0 104.814 14.1101 67.3843 39.5245 41.154C64.9122 14.9237 101.791 0 147.222 0L156.228 0.0267796ZM153.93 199.875C168.601 199.875 179.985 195.053 187.628 186.265C195.298 177.477 199.36 164.964 199.36 149.826C199.36 133.134 195.298 119.845 187.628 110.869C179.985 101.867 168.601 96.9369 153.93 96.9369H151.07C136.399 96.9369 125.014 101.76 117.371 110.869C109.701 119.979 105.64 133.134 105.64 149.826C105.64 165.098 109.701 177.584 117.371 186.265C125.014 194.919 136.399 199.875 151.07 199.875H153.93Z"
        fill="#00FFE0"
      />
    </svg>
  </span>
</template>
<script setup lang="ts"></script>

<style scoped lang="postcss">
.logo-animated-o {
  display: inline-block;

  > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
